// @flow
import attributesTranslations from 'locale/aidu-ch/attributes.json';
import bookingFormTranslations from 'locale/aidu-ch/bookingForm.json';
import confirmationPageTranslations from 'locale/aidu-ch/confirmationPage.json';
import ctaTranslations from 'locale/aidu-ch/cta.json';
import generalTranslations from 'locale/aidu-ch/general.json';
import inviaTypesTranslations from 'locale/aidu-ch/inviaTypes.json';
import legalTranslation from 'locale/aidu-ch/legal.json';
import travelOverlayTranslations from 'locale/aidu-ch/travelOverlay.json';
import unitsTranslations from 'locale/aidu-ch/units.json';

export default {
  attributes: attributesTranslations,
  bookingForm: bookingFormTranslations,
  confirmationPage: confirmationPageTranslations,
  cta: ctaTranslations,
  general: generalTranslations,
  inviaTypes: inviaTypesTranslations,
  legal: legalTranslation,
  units: unitsTranslations,
  travelOverlay: travelOverlayTranslations
};
